import React, { useContext, useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux'
import { withTranslation } from "react-i18next";
import { Form, Input, InputNumber, Popconfirm, Table, Radio, Space, Select } from 'antd';

import * as types from 'reducer/actionTypes';
import { isEmpty } from 'script/common';

const { Search } = Input;
const EditableContext = React.createContext(null);
const EditableRow = ({ index, ...props }) => {
	const [form] = Form.useForm();
	return (
	  <Form form={form} component={false}>
		<EditableContext.Provider value={form}>
		  <tr {...props} />
		</EditableContext.Provider>
	  </Form>
	);
  };

const EditableCell = ({
	title,
	addType,
	editable,
	children,
	dataIndex,
	record,
	onChangeKey,
	...restProps
  }) => {
	const [editing, setEditing] = useState(false);
	const inputRef = useRef(null);
	const form = useContext(EditableContext);
	useEffect(() => {
		if (editing) inputRef.current.focus();
	}, [editing]);
	
	const toggleEdit = () => {
		setEditing(!editing);
		form.setFieldsValue({[dataIndex]: record[dataIndex],});
	};
	
	const validationCheck = async () => {
	  try {		
			const values = await form.validateFields();
			toggleEdit();
			onChangeKey({
				...record,
				...values,
			});
		} catch (errInfo) {
		}
	};
	
	let childNode = children;
	let rulesValue = (title === 'key') ? [{ required: true, message: `${title} is required.`,}] : null;
	let nameElement = (title === 'key') ? 'setting_key' : 'setting_value';
 	if (editable) {  
		childNode = editing ? (
			<Form.Item 
				style={{ margin: 0}} 
				name={ dataIndex } 
				rules={ rulesValue }
			>
				<Input ref={inputRef} name={nameElement} onPressEnter={validationCheck} onBlur={validationCheck}/>
			</Form.Item>
		) : ( <div className="editable-cell-value-wrap" name={nameElement} style={{ paddingRight: 24 }} onClick={toggleEdit}> {children} </div> );		
	}
	return <td {...restProps}>{childNode}</td>;
  };

class SettingAdditional extends React.Component {
	componentWillMount() {
		this.props.fetchGetSettingAdditionalList(this.props.settingKey)
	}

	render(){
		const APP_NAME_CELL = "CELL";
		const APP_NAME_SHOW = "SHOW";
		const DISPLAY_APP_NAME_CELL = "SPREADSHEET";
		const DISPLAY_APP_NAME_SHOW = "PRESENTATION";
		const {t} = this.props;
		const onSaveSettingAdditional = (value) => {
			this.props.fetchSetSettingAdditional(
				value,
				{type: types.FETCH_GET_SETTING_ADDTIONAL_LIST_REQUEST}
			)

		}
		
		const onClickSave = (e) => {
			e.preventDefault();
			let value = [];
			try {
				this.props.additionalData.map((data,i) => {
					if (isEmpty(data.key))  throw new Error('Please check key!')
					if (isEmpty(data.value)) throw new Error('Please check value!')

           			// data.app 변경
					if (data.app === DISPLAY_APP_NAME_CELL) data.app = APP_NAME_CELL;
					if (data.app === DISPLAY_APP_NAME_SHOW) data.app = APP_NAME_SHOW;

					let isApp = this.props.apps.filter(a => a.value === data.app)
					if (!isEmpty(isApp)) data = {...data, key: data.key + "_" + data.app}

					let isExists = value.filter(v => v.key === data.key)
					if (!isEmpty(isExists)) throw new Error('The same key already exists.')
					
					value.push(data)
				})

				if (!isEmpty(value)) {
					onSaveSettingAdditional(value)
				}
			} catch(error) {
				this.props.alertMessage(error)
			}
		}
		
		const onClickDelete = (row) => {
			if (row.type === 'add') {
				let newData = this.props.additionalData.filter(data => data._id !== row._id)
				this.props.setSettingAdditionalData(newData)

			} else {
				let value = [];

				let deleteKey = row.key;
				let isApp = this.props.apps.filter(a => a.value === row.app)
				if (!isEmpty(isApp)) deleteKey = row.key + "_" + row.app

				value.push({
					...row,
					key: deleteKey,
					type: 'delete'
				})

				onSaveSettingAdditional(value)
			}
		}

		const onClickAdd = () => {
			const id = Math.random();
			const newData = {
				_id: id,
				key: '',
				app: 'ALL',
				value: '',				
				type: 'add',
				dataType: null,
			}
			
			let value = this.props.additionalData;
			value = [...value, newData]
			this.props.setSettingAdditionalData(value)
		};

		const onChangeApp = (e,row) => {
			const newData = this.props.additionalData.map((data) => {
				if (data._id === row._id) {
					return {
						...row,
						app: e,
						type: isEmpty(row.type) ? 'update' : row.type
					}
				} else {
					return ({
						...data
					})
				}
			})

			this.props.setSettingAdditionalData(newData)
		}

		const onChangeValue = (e,row) => {
			const newData = this.props.additionalData.map((data) => {
				if (data._id === row._id) {
					return {
						...row,
						value: e,
						type: isEmpty(row.type) ? 'update' : row.type
					}
				} else {
					return ({
						...data
					})
				}
			})

			this.props.setSettingAdditionalData(newData)
		}

		const setDisplayAppName = (dataValue) => {
			if (dataValue === APP_NAME_CELL) return DISPLAY_APP_NAME_CELL
			if (dataValue === APP_NAME_SHOW) return DISPLAY_APP_NAME_SHOW
			return dataValue
		}

		return(
			<div name="setting_data">
				<div style={{ margin: 20, textAlign: 'right' }}>{t('setting.additional.guide')}</div>
				<Table
					style={{ margin: 20 }}
					bordered
					pagination={false}
					components={{
						body: {
							row: EditableRow, 
							cell: EditableCell
						}
					}}
					columns={[
						{
							title: 'key',
							key: 'key',
							dataIndex: 'key',
							render: ((_,record) => {
								if (record.type === 'add') {
									return (<Search
										allowClear
										enterButton
										placeholder="input search text"
										defaultValue = {record.key}
										onSearch={(key) => this.props.fetchGetSettingAddtionalDefaultKeyInfo(key, record)}
									/>)
								} else {
									return record.key
								}
							})
						},
						{
							title: 'app',
							key: 'app',
							dataIndex: 'app',
							render: ((_, record) => {
								const dataType = record.dataType
								let dataValue = record.app

								if (!isEmpty(dataValue)) {
									dataValue = setDisplayAppName(dataValue)
								}

								if (isEmpty(dataType)) {
									return (<Input value={dataValue} readOnly disabled={true}/>)
								} else {
									if (record.type === 'add') {
										return (<Select 
											className="item_select"
											defaultValue={dataValue} 
											onChange={(e) =>onChangeApp(e, record)}
											options={[...this.props.displayAppNames, {key: "app.all", value: "ALL"}]}/>)
									} else {
										return isEmpty(dataValue) ? 'ALL' : dataValue
									}
								}
							})
						},
						{
							title: 'value',
							key: 'value',
							dataIndex: 'value',
							render: ((_,record) => {
								const dataType = record.dataType
								const dataValue = record.value

								if (isEmpty(dataType)) {
									return (<Input value={dataValue} readOnly disabled={true}/>)
								} else {
									if (dataType === 'String') {
										return (<Input defaultValue={dataValue} onChange={(e) => onChangeValue(e.target.value, record)}/>)
									} else if (dataType==='Boolean') {
										return (<Radio.Group  defaultValue={dataValue} onChange={(e) => onChangeValue(e.target.value, record)}>
													<Radio value={true}>True</Radio>
													<Radio value={false}>False</Radio>
												</Radio.Group>
												)
									} else if (dataType === 'Integer') {
										return (<InputNumber defaultValue={dataValue} onChange={(e) => onChangeValue(e, record)}></InputNumber>)
									}
								}

							})
						},
						{
							title: 'type',
							key: 'dataType',
							dataIndex: 'dataType',
							width: '10%',
						},
						{
							title: 'operation',
							key: 'operation',
							dataIndex: 'operation',
							width: '5%',
							render: (_, record) =>(<Popconfirm title="Sure to delete?" onConfirm={() => onClickDelete(record)}> <a>Delete</a> </Popconfirm>)
						},
					]}
					rowClassName={() => 'editable-row'}
					id={'setting_table'}
					dataSource={this.props.additionalData}
				>
				</Table>
				<Space style={{ float: 'right', marginRight: 20 }}>
					<button className="btn_text_b icon_btn" onClick={onClickSave}> Save </button>
					<button  className="btn_text_b icon_btn" onClick={onClickAdd}> <span className="icon_add"></span>Add a row </button>
				</Space>
			</div>
		)
	}
}

// state를 해당 컴포넌트의 props로 연결
const mapStateToProps = (reducers) => {
	return {
		apps: reducers.setting.apps,
		displayAppNames: reducers.setting.displayAppNames,
		settingKey: reducers.setting.settingKey,
		additionalData: reducers.setting.additionalData,
		apiCalling: reducers.apiCalling.apiCalling,
	}
}

// 컴포넌트의 함수형 poprs를 실행했을때, 지정한 action을 dispatch 하도록 설정
const mapDispatchToProps = (dispatch) => {
	return{
		setSettingAdditionalData: (value) => {dispatch({type: types.SET_SETTING_ADDITIONAL_DATA, value:value})},
		fetchGetSettingAdditionalList: () => {dispatch({type: types.FETCH_GET_SETTING_ADDTIONAL_LIST_REQUEST})},
		fetchGetSettingAddtionalDefaultKeyInfo: (key, row) => {dispatch({type: types.FETCH_GET_SETTING_ADDITIONAL_DEFAULT_KEY_INFO_REQUEST, key: key, row: row})},
		fetchSetSettingAdditional: (value, reloadAction) => {dispatch({type: types.FETCH_SET_SETTING_ADDITIONAL_DATA_REQUEST, value: value, reload: reloadAction})},
	}
}

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(SettingAdditional))